import Immutable from 'immutable';
import moment from 'moment';
import { MONTH_DATE_YEAR_FORMAT } from '../../constants';

const LOAD = 'toDoSuspenses/LOAD';
const LOAD_ALL_SUCCESS = 'toDoSuspenses/LOAD_ALL_SUCCESS';
const LOAD_SUCCESS = 'toDoSuspenses/LOAD_SUCCESS';
const LOAD_FAIL = 'toDoSuspenses/LOAD_FAIL';
const LOAD_ADD_SUCCESS = 'toDoSuspenses/LOAD_ADD_SUCCESS';
const LOAD_UPDATE_SUCCESS = 'toDoSuspenses/LOAD_UPDATE_SUCCESS';

const LOAD_SUSPENSE = 'toDoSuspenses/LOAD_SUSPENSE';

const OWNERCHOICES_LOAD = 'toDoSuspenses/OWNERCHOICES_LOAD';
const OWNERCHOICES_LOAD_SUCCESS = 'toDoSuspenses/OWNERCHOICES_LOAD_SUCCESS';
const OWNERCHOICES_LOAD_FAIL = 'toDoSuspenses/OWNERCHOICES_LOAD_FAIL';

const TODOLOGS_LOAD = 'toDoSuspenses/TODOLOGS_LOAD';
const TODOLOGS_LOAD_SUCCESS = 'toDoSuspenses/TODOLOGS_LOAD_SUCCESS';
const TODOLOGS_LOAD_FAIL = 'toDoSuspenses/TODOLOGS_LOAD_FAIL';

const DROPDOWNCHOICES_LOAD = 'toDoSuspenses/DROPDOWNCHOICES_LOAD';
const DROPDOWNCHOICES_LOAD_SUCCESS = 'toDoSuspenses/DROPDOWNCHOICES_LOAD_SUCCESS';
const DROPDOWNCHOICES_LOAD_FAIL = 'toDoSuspenses/DROPDOWNCHOICES_LOAD_FAIL';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  toDoSuspenses: [],
  toDoLogs: null,
  dropDownChoices: null,
  ownerChoices: null,
  loading: false,
  suspenseActivePage: 1,
  toDoSuspensesOffset: null,
  logsActivePage: 1,
  toDoSuspense: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('toDoSuspenses', null);

    case LOAD_ALL_SUCCESS:
      return state
        .set('isLoad', false)
        .set('toDoSuspenses', action.toDoSuspenses);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('suspenseActivePage', action.page)
        .set('toDoSuspensesOffset', action.toDoSuspenses);

    case LOAD_ADD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('toDoSuspensesOffset', action.result);


    case LOAD_UPDATE_SUCCESS:
      return state
        .set('isLoad', false)
        .set('toDoSuspenses', action.toDoSuspenses);

    case OWNERCHOICES_LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case OWNERCHOICES_LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('ownerChoices', null);

    case OWNERCHOICES_LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('ownerChoices', action.ownerChoices);

    case TODOLOGS_LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case TODOLOGS_LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('toDoLogs', null);

    case TODOLOGS_LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('logsActivePage', action.page)
        .set('toDoLogs', action.toDoLogs);

    case DROPDOWNCHOICES_LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case DROPDOWNCHOICES_LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('dropDownChoices', null);

    case DROPDOWNCHOICES_LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('dropDownChoices', action.dropDownChoices);

    case LOAD_SUSPENSE:
      return state
        .set('toDoSuspense', action.result);

    default:
      return state;
  }
}

export const getToDoSuspenses = (searchCriteria = null) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/ToDoSuspenses/', { params: searchCriteria });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    let list = res.sort((prev, next) => moment(prev.dueDate).diff(moment(next.dueDate)));
    list = list.map(item => {
      return {
        id: item.id,
        description: item.description,
        dueDate: item.dueDate,
        frequency: item.frequency,
        isCompleted: item.isCompleted,
        notificationTime: item.notificationTime,
        ownerName: item.ownerName || ''
      };
    })
    dispatch({ type: LOAD_ALL_SUCCESS, toDoSuspenses: list });

    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const createNew = () => async (dispatch) => {
  dispatch({ type: LOAD_SUSPENSE, result: {} });
};

export const getToDoSuspensesByOffset = (offset, page, notifTime, owner) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });

  let params = {}
  if (notifTime) {
    params.notifTime = notifTime
  }
  if (owner) {
    params.owner = owner
  }
  try {
    let res = await api.get(`/ToDoSuspenses/offset/${offset}`, { params });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, toDoSuspenses: res, page });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getToDoSuspensesById = (id) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/ToDoSuspenses/' + id);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    let Frequency = '';
    let NotificationTime = '';

    // Frequency (Recurring)
    if (res.old_id) {
      switch (res.frequency) {
        case "12":
          Frequency = "4";
          break;

        case "6":
          Frequency = "3";
          break;

        case "3":
          Frequency = "2";
          break;

        default:
          Frequency = ''
          break;
      }

      // Notification
      switch (res.frequency) {
        case "0":
          NotificationTime = "30";
          break;

        case "1":
          NotificationTime = "7";
          break;

        case "3":
          NotificationTime = "1";
          break;

        default:
          NotificationTime = ''
          break;
      }
    }

    const data = {
      id: res.id,
      description: res.description,
      dueDate: moment(res.dueDate).utc().format(MONTH_DATE_YEAR_FORMAT),
      frequency: Frequency ? Number(Frequency) : Number(res.frequency),
      notificationTime: NotificationTime ? Number(NotificationTime) : Number(res.notificationTime),
      ownerName: res.ownerName,
      isCompleted: res.isCompleted
    };
    dispatch({ type: LOAD_SUSPENSE, result: data });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};


export const addToDoSuspenses = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/ToDoSuspenses/', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const updateToDoSuspenses = (data) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });

  try {
    const res = await api.put('/ToDoSuspenses/', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const deleteToDoSuspenses = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.del('/ToDoSuspenses/', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const suspenses = getState().get('toDoSuspenses').get('toDoSuspenses');
    const list = suspenses.filter(suspens => suspens.id !== data.id);

    dispatch({ type: LOAD_ALL_SUCCESS, toDoSuspenses: list });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const getToDoLogs = () => async (dispatch, getState, api) => {
  dispatch({ type: TODOLOGS_LOAD });
  try {
    const res = await api.get(`/ToDoSuspenses/ToDoLogs`);
    if (res.message) {
      dispatch({ type: TODOLOGS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: TODOLOGS_LOAD_SUCCESS, toDoLogs: res });
    return res;
  } catch (error) {
    dispatch({ type: TODOLOGS_LOAD_FAIL, errorMessage: error });
  }
};

export const getDropDownChoices = () => async (dispatch, getState, api) => {
  dispatch({ type: DROPDOWNCHOICES_LOAD });
  try {
    const res = await api.get('/ToDoSuspenses/DropDownChoices/');
    if (res.message) {
      dispatch({ type: DROPDOWNCHOICES_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: DROPDOWNCHOICES_LOAD_SUCCESS, dropDownChoices: res });
  } catch (error) {
    dispatch({ type: DROPDOWNCHOICES_LOAD_FAIL, errorMessage: error });
  }
};
export const getOwnerChoices = () => async (dispatch, getState, api) => {
  dispatch({ type: OWNERCHOICES_LOAD });
  try {
    const res = await api.get('/ToDoSuspenses/OwnerChoices/');
    if (res.message) {
      dispatch({ type: OWNERCHOICES_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: OWNERCHOICES_LOAD_SUCCESS, ownerChoices: res });
  } catch (error) {
    dispatch({ type: OWNERCHOICES_LOAD_FAIL, errorMessage: error });
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/toDoSuspenses.js